import { createFileRoute, notFound } from "@tanstack/react-router";

import { CONTENT_NOT_FOUND_CACHE_CONTROL } from "@/content/cachePolicy";
import { NotFoundPage } from "@/components/landing/LandingNotFound";

/**
 * `/proxy-locations` with no country on it.
 *
 * The published site has no index here, it answers 404, and only the
 * seventy-five `/proxy-locations/:slug` pages exist. Without this route the
 * layout still matches the bare path and renders its header and footer around
 * an empty outlet, which is a 200 carrying no content: the blank render the
 * ticket rules out, and a thin page for a crawler to index.
 */
export const Route = createFileRoute("/proxy-locations/")({
  loader: () => {
    throw notFound();
  },
  headers: () => ({ "Cache-Control": CONTENT_NOT_FOUND_CACHE_CONTROL }),
  notFoundComponent: NotFoundPage,
});
